import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

export const useStyles = makeStyles((theme: ITheme) => ({
  root: () => ({
    height: '330px',
    width: '350px',
    fontFamily: 'DM Serif Display',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    backgroundColor: colors.white,
  }),
  content: {
    display: 'block',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '70%',
    [theme.breakpoints.up('lg')]: {
      maxWidth: 323,
    },
  },
  sessionContainer: {
    backgroundColor: colors.lightBlue,
  },
  sessionTable: {
    width: '100%',
    position: 'relative',
    left: 0,
    right: 0,
  },
  sessionHeader: {
    maxHeight: '64px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingBottom: theme.spacing(1),
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
  sessionRow: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sessionCellLeft: {
    display: 'table-cell',
    verticalAlign: 'top',
  },
  sessionCellRight: {
    display: 'table-cell',
    verticalAlign: 'top',
    paddingLeft: theme.spacing(1),
  },
  sessionCounter: {
    color: colors.darkGray,
  },
  sessionDate: {
    paddingTop: '8px',
  },
  dayOfTheWeek: {
    paddingBottom: theme.spacing(1.5),
  },
  cardActions: {
    width: '100%',
    textAlign: 'center',
  },
  cardBottomText: {
    height: '100%',
  },
  valueBold: {
    fontWeight: 'bold',
  },
  cardButton: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  customTooltip: {
    borderRadius: theme.spacing(1),
  },
  cardContent: {
    display: 'grid',
    margin: '24px 0',
    gap: 24,
  },
}));
